module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_8017.e8e6e8d6.png";